import { formatDate } from "@angular/common";
import { Inject, LOCALE_ID, Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "localDate"
})
export class LocalDatePipe implements PipeTransform {
  constructor(
    @Inject(LOCALE_ID) private locale: string
  ) { }

  transform(value: any, ...args: any[]) {
    const localDate = new Date(value + 'Z');
    return formatDate(localDate, 'MM/dd/yyyy h:mm a', this.locale);
  }
}
